import { DashboardLeadReadable, dashboardLeadsListOptions } from '@crm/api'
import { useStyles } from '@crm/features/dashboard/styles'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { TableContainer } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, Flex, Space } from 'antd'
import cn from 'classnames'
import { v4 as uuidv4 } from 'uuid'

import type { TableColumnsType } from 'antd'

export const RecentLeads = () => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const navigate = useAppNavigate()
  const { params } = useQueryUpdate()

  const { data = [], isLoading } = useQuery(
    dashboardLeadsListOptions({ query: params })
  )

  const columns: TableColumnsType<DashboardLeadReadable> = [
    {
      title: t('nomenclature.name'),
      render: (_, record) => record?.name ?? '-'
    },
    {
      title: t('lead.status'),
      dataIndex: ['status', 'name']
    }
  ]

  const onRow = (data: DashboardLeadReadable) => {
    return {
      onClick: () => {
        navigate(`${paths.leads}/${data?.id}`)
      }
    }
  }

  return (
    <Card
      className={cn(
        styles.card,
        styles.flexGrowDashboardCharts,
        'card-body-no-padding'
      )}
      variant="borderless"
      loading={isLoading}
      title={t('reports.recent_leads')}
      actions={[
        <Flex key="recent-leads-actions" justify="space-between" align="center">
          <Space size="small">
            {`${t('reports.total')}:`}

            {data?.length}
          </Space>

          <Button
            onClick={() =>
              navigate(
                `${paths.leads}${params?.user ? `?owner=${params?.user}` : ''}`
              )
            }
            type="primary"
          >
            {t('reports.view_all')}
          </Button>
        </Flex>
      ]}
    >
      <TableContainer
        rowKey={() => uuidv4()}
        onRow={onRow}
        columns={columns}
        data={{ results: data ?? [], count: data?.length }}
        pagination={false}
        showSearch={false}
        rowClassName="pointer"
        showSorterTooltip={false}
      />
    </Card>
  )
}
